import { Injectable } from '@angular/core';

import { AuthGuardService } from '@shared/services';

@Injectable()
export class StoreStockRecallPermissionService {
  constructor(protected authGuardService: AuthGuardService) {}

  public get hasManageStoreStockRecall(): boolean {
    return this.authGuardService.checkPermission(['recall_m']);
  }

  public get hasViewStoreStockRecall(): boolean {
    return this.authGuardService.checkPermission(['recall_v']);
  }
}
